import { CoreBaseApi, CoreBaseApiResult } from "./CoreBaseApi";

export class CoreBaseApiEndpoint {
    
    constructor(protected api: CoreBaseApi) {
        
    }
}